// const Banner = ({text})=>{
//     return(
//         <div className="banner">
//             <h1>{text}</h1>
//         </div>
//     );
// }

// export default Banner;


import React from 'react';

const Banner = ({ text }) => {
  return (
    <div className="banner-container flex justify-center bg-transparent p-4 rounded-md animate-bounce">
      <p className="banner-text text-red-500 font-bold text-3xl animate-pulse">{text}</p> &nbsp;
    </div>
  );
};

export default Banner;